import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PriceRaiseHistoryModalSchema } from '../types';

const initialState: PriceRaiseHistoryModalSchema = {
  contractId: null,
};

const priceRaiseHistoryModalSlice = createSlice({
  name: 'priceRaiseHistoryModal',
  initialState,
  reducers: {
    openModal: (state: PriceRaiseHistoryModalSchema, action: PayloadAction<string>) => {
      state.contractId = action.payload;
    },
    closeModal: (state: PriceRaiseHistoryModalSchema) => {
      state.contractId = null;
    },
  },
});

export const { actions: priceRaiseHistoryModalActions, reducer: priceRaiseHistoryModalReducer } = priceRaiseHistoryModalSlice;
